import { toStatisticFeatures } from '@components/map/layers/statistics/statistic.mapper';
import { createToast, ToastStatusEnum } from '@components/ui/toaster';
import { useGetDroneTrajectoriesMutation, useLazyGetNotificationsQuery } from '@services/data/notification.api';
import { FeatureCollection } from 'geojson';
import { useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { DroneTrajectories, NotificationCriteria } from '@/types/data/data.types';

function toStatisticFeatureCollection(notifications: DroneTrajectories[]): FeatureCollection {
  return {
    type: 'FeatureCollection',
    features: toStatisticFeatures(notifications),
  };
}

export function useFindAllWithDetails(criteria: NotificationCriteria | null) {
  const { formatMessage } = useIntl();

  const [triggerCallGetNotifications, { isLoading: isLoadingLight }] = useLazyGetNotificationsQuery();
  const [getDroneTrajectories, { data: droneTrajectories = [], isLoading: isLoadingDetails }] =
    useGetDroneTrajectoriesMutation();

  useEffect(() => {
    if (criteria) {
      triggerCallGetNotifications(criteria)
        .then((result) => {
          const notifIds = result.data?.map((notif) => notif.id);
          if (notifIds) {
            getDroneTrajectories({ ids: notifIds });
          }
        })
        .catch(() =>
          createToast(
            formatMessage({ id: 'components.notificationSearch.statistics.error.loadNotifications' }),
            ToastStatusEnum.ERROR,
          ),
        );
    }
  }, [criteria, formatMessage, getDroneTrajectories, triggerCallGetNotifications]);

  const features = useMemo(() => toStatisticFeatureCollection(droneTrajectories), [droneTrajectories]);

  return {
    data: features,
    isLoading: isLoadingLight || isLoadingDetails,
  };
}
